{
  "LOGIN": {
    "TITLE": "تسجيل الدخول إلى مركز الاتصال",
    "EMAIL": {
      "LABEL": "البريد الإلكتروني",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "الرجاء إدخال عنوان بريد إلكتروني صحيح"
    },
    "PASSWORD": {
      "LABEL": "كلمة المرور",
      "PLACEHOLDER": "كلمة المرور"
    },
    "API": {
      "SUCCESS_MESSAGE": "تم تسجيل الدخول بنجاح",
      "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً",
      "UNAUTH": "اسم المستخدم / كلمة المرور غير صحيحة. الرجاء المحاولة مرة أخرى",
      "ACCOUNT_DEACTIVATED": "تم إلغاء تفعيل حسابك. يرجى التواصل مع المسؤول.",
      "PASSWORD_LOGIN_DISABLED": "تسجيل الدخول بكلمة المرور معطّل لحسابك. يرجى تسجيل الدخول باستخدام OAuth (مثل Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "تسجيل الدخول بواسطة جوجل",
      "BUSINESS_ACCOUNTS_ONLY": "الرجاء استخدام عنوان البريد الإلكتروني الخاص بشركتك لتسجيل الدخول",
      "NO_ACCOUNT_FOUND": "لم نتمكن من العثور على حساب لعنوان البريد الإلكتروني الخاص بك."
    },
    "FORGOT_PASSWORD": "نسيت كلمة المرور؟",
    "CREATE_NEW_ACCOUNT": "إنشاء حساب جديد",
    "SUBMIT": "تسجيل الدخول"
  }
}
